<template>
  <div class="odmik-naroci-televizija">
    <p class="navadno-besedilo">
      Izbrani programski shemi dodajte poljubno število posameznih programov visoke ločljivosti (HD) in si
      s tem zagotovite popoln televizijski užitek.
    </p>
    <div class="postavitev-paketi-televizija" v-loading="nalaganjeHdProgramov">
      <div class="postavitev-programov-hd-paket" v-for="posamezenProgramHd in seznamHDprogramov">
        <div>
          <div class="open-sans-24pt">
            <b>
              {{posamezenProgramHd.naziv.toUpperCase()}}
            </b>
          </div>
          <div class="podcrtan-naziv-paketi"/>
          <br/>
          <el-col class="izpis-opisa-hd-paket"> {{posamezenProgramHd.opis}}
          </el-col>
          <div class="izpis-cena-hd-paket">
            {{posamezenProgramHd.cenaSI}} € / mesec
          </div>
          <div>
            <div>
              <OrderButton
                v-if="posamezenProgramHd.vklopljeno === 0 && posamezenProgramHd.naroceno === 0
                      || posamezenProgramHd.vklopljeno === 1 && posamezenProgramHd.naroceno === 1"
                :services="[{serviceId: posamezenProgramHd.id, quantity: 1, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                class="postavitev-gumb-narocanje"
                :service-name="'TV paket ' + posamezenProgramHd.naziv.toUpperCase()"
                style="width: 170px;"
                @orderConfirmed="osveziPodatke(); $emit('orderConfirmed')"
              >
                NAROČI PROGRAM
              </OrderButton>
              <OrderButton
                v-if="posamezenProgramHd.vklopljeno === 1 && posamezenProgramHd.naroceno === 0
                      && posamezenProgramHd.odjava_cez === null"
                :services="[{serviceId: posamezenProgramHd.id, quantity: 0, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                class="postavitev-gumb-narocanje"
                :service-name="'TV paket ' + posamezenProgramHd.naziv.toUpperCase()"
                style="width: 170px;"
                @orderConfirmed="osveziPodatke(); $emit('orderConfirmed')"
              >
                ODJAVI PROGRAM
              </OrderButton>
              <div class="postavitev-gumb-odjava-na-voljo-cez-30-dni"
                   v-if="posamezenProgramHd.naroceno === 1">
                <el-button type="primary" class="gumb-potrdi" disabled>
                  NAROČILO V TEKU
                </el-button>
              </div>
              <div class="postavitev-gumb-odjava-na-voljo-cez-30-dni"
                   v-if="posamezenProgramHd.odjava_cez === 1">
                <el-button type="primary" class="gumb-potrdi" disabled>
                  ODJAVA NA VOLJO ČEZ {{ posamezenProgramHd.odjava_cez }} DNI
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OrderExistsInfo v-if="orderExists"/>
    <div>
      <InfoKomponenta/>
    </div>
  </div>
</template>
<script>
  import ClientAgent from '../../../../../assets/js/clientAgent.js'
  import {Button, Col} from 'element-ui'
  import InfoKomponenta from './InfoKomponenta'
  import OrderButton from '../../../../UIComponents/OrderButton.vue'
  import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'

  export default {
    name: 'TVhdProgrami',
    data () {
      return {
        nalaganjeHdProgramov: false,
        seznamPridobljenihPodatkov: [],
        seznamVklopljenih: [],
        orderExists: false
      }
    },
    components: {
      InfoKomponenta,
      [Button.name]: Button,
      [Col.name]: Col,
      OrderExistsInfo,
      OrderButton
    },
    props: {
      izbranPrikljucek: null,
      seznamHDprogramov: null
    },
    mounted () {
      this.osveziPodatke()
      this.clientAgent = new ClientAgent()
    },
    methods: {
      osveziPodatke () {
        this.reloadOrderExists()
      },
      async reloadOrderExists () {
        if (this.izbranPrikljucek !== null) {
          let orderExistsTmp = false
          this.seznamHDprogramov.forEach((p) => {
            if (p.naroceno === 1) {
              orderExistsTmp = true
            }
          })
          this.orderExists = orderExistsTmp
        }
      }
    }
  }
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelevizija/TVhdProgrami.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/TVhdProgrami.vue